import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = (accountId, featureFlag) => {
  const items = [
    {
      icon: 'fi fi-sr-layout-fluid',
      key: 'dashboard',
      label: 'DASHBOARD',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toStateName: 'home',
      roles: ['administrator'],
    },
    {
      icon: 'fi fi-sr-messages',
      key: 'conversations',
      label: 'CONVERSATIONS',
      toState: frontendURL(`accounts/${accountId}/conversation`),
      toStateName: 'home',
      roles: ['administrator', 'agent'],
    },
    {
      icon: 'fi fi-sr-ballot',
      key: 'contacts',
      label: 'CONTACTS',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
      roles: ['administrator', 'agent'],
    },
    {
      icon: 'fi fi-sr-crm-computer',
      key: 'crm',
      label: 'CRM',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/crm`),
      toStateName: 'kanban',
      roles: ['administrator', 'agent'],
    },
    {
      icon: 'fi fi-sr-search-alt',
      key: 'smartsurvey',
      label: 'SMART_SURVEY',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/smart_survey`),
      toStateName: 'smart_survey',
      roles: ['administrator', 'agent'],
    },
    {
      icon: 'fi fi-sr-user-robot',
      key: 'typebot',
      label: 'TYPEBOT',
      featureFlag: FEATURE_FLAGS.CRM,
      toState: frontendURL(`accounts/${accountId}/omnibot`),
      toStateName: 'typebot',
      roles: ['administrator', 'agent'],
    },
    {
      icon: 'fi fi-sr-megaphone',
      key: 'campaigns',
      label: 'CAMPAIGNS',
      featureFlag: FEATURE_FLAGS.CAMPAIGNS,
      toState: frontendURL(`accounts/${accountId}/campaigns`),
      toStateName: 'settings_account_campaigns',
      roles: ['administrator'],
    },
    {
      icon: 'fi fi-sr-sitemap',
      key: 'campaigns_flow',
      label: 'CAMPAIGNS_FLOW',
      featureFlag: FEATURE_FLAGS.CAMPAIGNS_FLOW,
      toState: frontendURL(`accounts/${accountId}/campaigns_flow`),
      toStateName: 'campaigns_flow',
      roles: ['administrator', 'agent'],
    },
    {
      icon: 'fi fi-sr-square-w',
      key: 'wise',
      label: 'WISE',
      featureFlag: FEATURE_FLAGS.WISE,
      toState: frontendURL(`accounts/${accountId}/wise/dashboard`),
      toStateName: 'wise_dashboard',
      roles: ['administrator', 'agent', 'supervisor'],
    },
    {
      icon: 'fi fi-sr-books',
      key: 'helpcenter',
      label: 'HELP_CENTER.TITLE',
      featureFlag: FEATURE_FLAGS.HELP_CENTER,
      toState: frontendURL(`accounts/${accountId}/portals`),
      toStateName: 'default_portal_articles',
      roles: ['administrator'],
    },
    {
      icon: 'fi fi-sr-globe',
      key: 'dashboard_embed',
      label: 'DASHBOARD_EMBED',
      featureFlag: FEATURE_FLAGS.DASHBOARD_EMBED,
      toState: frontendURL(`accounts/${accountId}/dashboard_embed`),
      toStateName: 'dashboard_embed',
      roles: ['administrator'],
    },
  ];

  if (featureFlag?.[0]?.reports) {
    items.push({
      icon: 'fi fi-sr-chart-simple',
      key: 'reports',
      label: 'REPORTS',
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'settings_home',
      roles: ['administrator'],
    });
  }

  // Jornada ARC por último no menu (ícone velocímetro em RAIL_ICONS.arc_journey).
  items.push({
    icon: 'gauge',
    key: 'arc_journey',
    label: 'ARC_JOURNEY',
    featureFlag: FEATURE_FLAGS.ARC_JOURNEY,
    toState: frontendURL(`accounts/${accountId}/arc`),
    toStateName: 'arc_panel',
    roles: ['administrator', 'agent'],
  });

  return items;
};

export default primaryMenuItems;
